import { Dialog } from "primereact/dialog";
import FilePreview from "reactjs-file-preview";
import PropTypes from "prop-types";

import { ColaboraButton, PdfPreview } from "../";

/**
 * Dialog for previewing a file inline, with a download action in the footer.
 *
 * @param {object} props
 * @param {string} props.fileName - Displayed as the dialog header.
 * @param {string} [props.url] - URL of the file to preview.
 * @param {boolean} props.isPdf - Renders a PDF viewer when true, otherwise uses the generic file preview.
 * @param {boolean} props.visible - Controls dialog visibility.
 * @param {Function} props.onHide - Called when the dialog requests to close.
 * @param {Function} props.onDownload - Called when the download button is clicked.
 * @param {string} props.downloadLabel - Label for the download button.
 */
const FilePreviewDialog = ({
  fileName,
  url,
  isPdf,
  visible,
  onHide,
  onDownload,
  downloadLabel,
}) => (
  <Dialog
    header={fileName}
    visible={visible}
    style={{ width: "90vw", maxWidth: "800px" }}
    onHide={onHide}
    footer={
      <div className="flex justify-end pt-[1.5rem]">
        <ColaboraButton onClick={onDownload} label={downloadLabel} />
      </div>
    }
  >
    {isPdf ? <PdfPreview url={url} /> : <FilePreview preview={url} />}
  </Dialog>
);

FilePreviewDialog.propTypes = {
  fileName: PropTypes.string.isRequired,
  url: PropTypes.string,
  isPdf: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  downloadLabel: PropTypes.string.isRequired,
};

export default FilePreviewDialog;
